import { Injectable } from '@angular/core';

import { Observable, from } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { HttpClient, HttpHeaders }  from "@angular/common/http";

import apiconfig from '../apiconfig';

import { Subtype } from './subtype'

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(
        private http: HttpClient
  ) { }

  private substype: Subtype[] = []

  private handleError(error:any): any{
    console.log(error)
  }

  public getSubscriptionData(idToken, username): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    var input = "{ 'username':'"+username+"' , 'typeOp':'read' }"

    return from(
      this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'registration', 'input' : input.replace(/'/g, '"') },httpOptions),
    ).pipe(
      tap(() => console.log("getSubscriptionData"))
    );

  } // end getGetSubscriptionData

  public updateSubscriptionData(idToken, username, nome, cognomeRagSoc, piva, codFiscale, indirizzo, cap, citta, provincia, nazione, telefono, dest_fe, pec_fe, email): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    var input = "{ 'username':'"+username+"' , 'typeOp':'write', 'nome':'"+nome+"' ,'cognomeRagSoc':'"+cognomeRagSoc+"' ,'piva':'"+piva+"' , 'codFiscale':'"+codFiscale+"' ,'indirizzo':'"+indirizzo+"' ,'cap':'"+cap+"' ,'citta':'"+citta+"' ,'provincia':'"+provincia+"' ,'nazione':'"+nazione+"' ,'telefono':'"+telefono+"' ,'dest_fe':'"+dest_fe+"' ,'pec_fe':'"+pec_fe+"' ,'email':'"+email+"' }"

    return from(
      this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'registration', 'input' : input.replace(/'/g, '"') },httpOptions),
    ).pipe(
      tap(() => console.log("updateSubscriptionData"))
    );

  } // end updateGetSubscriptionData

  public getSubscriptionPayData(idToken, username): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    var input = "{ 'username':'"+username+"' , 'typeOp':'read' }"

    return from(
      this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'subscription', 'input' : input.replace(/'/g, '"') },httpOptions),
    ).pipe(
      tap(() => console.log("getSubscriptionPayData"))
    );

  } // end getGetSubscriptionData

  public getSubscriptionType(idToken){
      const httpOptions = {
        headers: new HttpHeaders({
            'Authorization': idToken
        })
      };

      var input = "{ 'typeOp':'type' }"

      return this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'subscription', 'input' : input.replace(/'/g, '"') },httpOptions)
        .toPromise()
        .then((data:any) => {
            console.log("*** dati fetchati da getSubscriptionType ***" + JSON.stringify(data));
            this.substype = data.subs;
            return this.substype;
          })
        .catch(err => this.handleError(Error))
    } // end readAllFaces

    public updateSubscriptionType(idToken, username, subtype): Observable<any> {

      const httpOptions = {
        headers: new HttpHeaders({
            'Authorization': idToken
        })
      };

      var input = "{ 'username':'"+username+"' , 'typeOp':'write', 'subscriptionType':'"+subtype+"' }"

      return from(
        this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'subscription', 'input' : input.replace(/'/g, '"') },httpOptions),
      ).pipe(
        tap(() => console.log("updateSubscriptionType"))
      );

    } // end updateGetSubscriptionType

}
